import React, { useMemo } from 'react';
import { Card } from 'antd';
import Plot from 'react-plotly.js';

const EnhancedVolatilityChart = ({ data }) => {
  const processedData = useMemo(() => {
    if (!data || !data.length) return { traces: [], annotations: [] };

    // Find the VIX indices
    const vix9d = data.find(d => d.name === '^vix9d');
    const vix = data.find(d => d.name === '^vix');
    const vix6m = data.find(d => d.name === '^vix6m');

    if (!vix || !vix9d || !vix6m) return { traces: [], annotations: [] };



    // Calculate spreads
    const spread9dVix = vix.y.map((val, i) => vix9d.y[i] - val);
    const spreadVix6m = vix6m.y.map((val, i) => val - vix.y[i]);

    const spreadTraces = [
      {
        name: '9D-VIX Spread',
        x: vix.x,
        y: spread9dVix,
        yaxis: 'y2',
        type: 'scatter',
        mode: 'lines',
        line: { color: '#2ca02c', width: 1, dash: 'dot' },
      },
      {
        name: 'VIX-6M Spread',
        x: vix.x,
        y: spreadVix6m,
        yaxis: 'y2',
        type: 'scatter',
        mode: 'lines',
        line: { color: '#d62728', width: 1, dash: 'dot' },
      }
    ];

    // Create state annotations
    let prevState = '';
    const annotations = vix.x.map((date, i) => {
      const spread1 = spread9dVix[i];
      const spread2 = spreadVix6m[i];
      let state = '';
      let color = '';

      if (spread1 > 1 && spread2 > 1) {
        state = 'High Vol Regime';
        color = '#d62728';
      } else if (spread1 < -1 && spread2 < -1) {
        state = 'Low Vol Regime';
        color = '#2ca02c';
      } else if (Math.abs(spread1) <= 1 && Math.abs(spread2) <= 1) {
        state = 'Normal Vol';
        color = '#7f7f7f';
      }

      // Only add annotation if state changes from previous
      if (state !== prevState) {
        prevState = state;
        return {
          x: date,
          y: 1.1 * Math.max(...vix6m.y),
          text: state,
          showarrow: true,
          arrowhead: 2,
          arrowsize: 1,
          arrowwidth: 1,
          arrowcolor: color,
          font: { color: color, size: 10 },
          ax: 0,
          ay: -30
        };
      }
      return null;
    }).filter(Boolean);

    return {
      traces: [ ...spreadTraces],
      annotations: annotations
    };
  }, [data]);

  const layout = {
    title: 'Enhanced Volatility Analysis',
    showlegend: true,
    hovermode: 'x unified',
    xaxis: {
      title: 'Date',
      showgrid: false,
    },
    yaxis: {
      title: 'Volatility Index Value',
      showgrid: true,
      gridcolor: 'rgba(0,0,0,0.1)',
    },
    yaxis2: {
      title: 'Spread Value',
      overlaying: 'y',
      side: 'right',
      showgrid: false,
      zeroline: true,
      zerolinecolor: 'rgba(0,0,0,0.2)',
      zerolinewidth: 1,
    },
    margin: { t: 40, b: 40, l: 60, r: 60 },
    plot_bgcolor: 'white',
    paper_bgcolor: 'white',
    annotations: processedData.annotations
  };

  return (
    <Card>
      <Plot
        data={processedData.traces}
        layout={layout}
        useResizeHandler
        style={{ width: '100%', height: '500px' }}
        config={{ responsive: true }}
      />
    </Card>
  );
};

export default EnhancedVolatilityChart;